import script from "./KInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./KInput.vue?vue&type=script&setup=true&lang=ts"

import "./KInput.vue?vue&type=style&index=0&id=a0869f92&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a0869f92"]])

export default __exports__
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInput,QField,QSpinner,QIcon});
